import { render, staticRenderFns } from "./PurchasesReport.vue?vue&type=template&id=7fe0d313"
import script from "./PurchasesReport.vue?vue&type=script&lang=js"
export * from "./PurchasesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe0d313')) {
      api.createRecord('7fe0d313', component.options)
    } else {
      api.reload('7fe0d313', component.options)
    }
    module.hot.accept("./PurchasesReport.vue?vue&type=template&id=7fe0d313", function () {
      api.rerender('7fe0d313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/PurchasesReport.vue"
export default component.exports